<script lang="ts">
	import type { PostGrid } from '#lib/schema-extension.js';
	import { setAttr } from '@directus/visual-editing';
	import PostCard from '#lib/components/PostCard.svelte';
	import Placeholder from '#lib/components/Placeholder.svelte';
	import { directusReadItems } from '../directus.remote.js';
	import { page } from '$app/state';

	let { block }: { block: PostGrid } = $props();

	const posts = $derived(
		directusReadItems({
			collection: 'posts',
			query: {
				filter: {
					status: page.url.searchParams.has('preview')
						? { _in: ['published', 'draft'] }
						: { _in: ['published'] },
					slug: block.wildcats ? { _starts_with: 'wildcats/' } : { _nstarts_with: 'wildcats/' },
					season:
						block.seasons && block.seasons.length > 0 ? { _in: block.seasons as number[] } : {}
				},
				fields: ['*', { season: ['title'] }],
				sort: '-date_created'
			}
		})
	);
</script>

<div
	class="flex w-full flex-col gap-3"
	data-directus={block.id &&
		setAttr({
			collection: 'postGrid',
			item: block.id,
			mode: 'modal'
		})}
>
	{#if block.title}
		<h2>{block.title}</h2>
	{/if}
	{#if block.exposeFilters}
		<div class="bg-base-100 flex w-full justify-between p-3">
			<h3>Filter</h3>
			<div class="flex gap-3">
				<div>Categories</div>
				<div>Seasons</div>
			</div>
		</div>
	{/if}
	{#await posts}
		<Placeholder text="Posts werden geladen" />
	{:then posts}
		{#if posts.length > 0}
			<div class="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
				{#each posts as post}
					<PostCard {post} />
				{/each}
			</div>
		{:else}
			<div class="bg-base-100 w-full p-3">Keine Posts gefunden</div>
		{/if}
	{/await}
</div>
